"use strict";

import lang from "vwa/lang";
import scalarToQuantity from "vwa/quantity/scalarToQuantity";
import filterGroups from "vwa/utils/filterGroups";
import getServiceSet from "vfu/getServiceSet";
import sessionStore from "./../store/session";
import dataTypeStore from "./../store/dataTypes";
import vehicleStore from "./../store/vehicles";
import vehicleStateStore from "./../store/vehicleStates";
import pinnedVehicleStore from "./../store/pinnedVehicles";
import {getUnitAssignment} from "./user";

import {positionToLatLng} from "./geo";

function getServiceSetOfVehicle(vehicleId) {
	const session = sessionStore.get();
	if (!session) return null;
	
	const vehicle = vehicleStore.get(vehicleId);
	if (!vehicle) return null;
	
	const vehicles = vehicleStore.getAll();
	if (!vehicles) return null;
	
	return getServiceSet("CarrierSet", "carrier", session.user, vehicle, vehicles);
}

export function getPrivilegeOfVehicle(vehicleId) {
	const serviceSet = getServiceSetOfVehicle(vehicleId);
	if (serviceSet && serviceSet.value && serviceSet.value.privilege !== undefined)
		return serviceSet.value.privilege;
	return null;
}

export function getScalarVehicleStatesWithResolvedUnits(vehicleId) {
	const vehicleState = vehicleStateStore.get(vehicleId);
	if (!vehicleState)
		return [];
	
	const unitAssignment = getUnitAssignment();
	
	return vehicleState.state
						.filter(data => data.type == "Scalar" || data.dataType == "54ac0f62f556ea16b4a31fd4")
						.map(data => {
				
							const dataTypeName = dataTypeStore.get(data.dataType).name;
							const name = lang[`DATA_TYPE_${data.dataType}`];
							if (data.dataType == "54ac0f62f556ea16b4a31fd4"){	//for LatLng coords
								const lat = data.point.coordinates[1];
								const lng = data.point.coordinates[0];
								return {dataTypeName,name,lat,lng};
							}
							
							const quantity = scalarToQuantity(dataTypeStore, unitAssignment, data);
							const value = quantity.value;
							const unit = quantity.unit || "";
							return {dataTypeName, name, value, unit};
						});
}

function getVehicleStateByDataTypeName(vehicleId, dataTypeName) {
	const vehicleState = vehicleStateStore.get(vehicleId);
	if (!vehicleState)
		return null;
	
	const dataTypeId = dataTypeStore.get(dataTypeName)._id;
	return vehicleState.state.find(s => s.dataType == dataTypeId) || null;
}

export function getBoundsOfPinnedVehicles() {
	const pinnedVehicles = pinnedVehicleStore.getAll();
	if (!pinnedVehicles)
		return null;
	const positions = pinnedVehicles
						.map(id => getPositionOfVehicle(id))
						.filter(_ => _);
	
	const bounds = new google.maps.LatLngBounds();
	positions.forEach(position => bounds.extend(position));
	return bounds;
}

export function getNumberOfPinnedVehicles() {
	const pinnedVehicles = pinnedVehicleStore.getAll();
	if (!pinnedVehicles)
		return 0;
	return pinnedVehicles.length;
}

export function getPositionOfVehicle(vehicleId) {
	const position = getVehicleStateByDataTypeName(vehicleId, "Position");
	
	if (position)
		return positionToLatLng(position);
	else return null;
}

export function getAddressOfVehicle(vehicleId) {
	const position = getVehicleStateByDataTypeName(vehicleId, "Position");
	
	if (position)
		return position.address || "";
	else return "";
}

export function getNameOfVehicle(vehicleId) {
	const vehicles = filterGroups(vehicleStore.getAll());
	if (!vehicles)
		return "";
	const vehicle = vehicles.find(v => v._id == vehicleId);
	if (vehicle)
		return vehicle.name || vehicle.plateNumber;
	else return "";
}

export function getMovingStateOfVehicle(vehicleId) {
	const ignitionData = getVehicleStateByDataTypeName(vehicleId, "Ignition");
	const maxSpeedData = getVehicleStateByDataTypeName(vehicleId, "MaxSpeed");
	const avgSpeedData = getVehicleStateByDataTypeName(vehicleId, "AvgSpeed");
	
	const ignition = ignitionData ? ignitionData.value : false;
	const speed = avgSpeedData ? avgSpeedData.value :
					(maxSpeedData ? maxSpeedData.value : 0);
	
	if (ignition && speed) return "moving";
	else if (ignition) return "onIgnition";
	else return "";
}

export function hasStateOfVehicle(vehicleId) {
	const vehicleState = vehicleStateStore.get(vehicleId);
	
	if (!vehicleState || vehicleState.state.length == 0)
		return false;
	return true;
}

export function getSelectionOfVehicle(vehicleId) {
	return selectedVehicleStore.get() == vehicleId;
}

export function getLastTimeOfVehicleState(vehicleId) {
	
	const vehicleState = vehicleStateStore.get(vehicleId);
	
	if (!vehicleState)
		return 0;
	
	return vehicleState.state.reduce(
		(last, data) => data.time > last ? data.time : last,
		0
	);
}


// WEBPACK FOOTER //
// ./src/utils/vehicle.js